import React from 'react';
import './Soluciones.css';

const Soluciones = () => {
    return (
        <section className="soluciones" id="soluciones">
            <div className="container">
                <div className="soluciones-header">
                    <div>
                        <div className="eyebrow rv in">Soluciones implementadas</div>
                        <h2 className="s-title rv in d1">Soluciones que ya<br />están funcionando</h2>
                    </div>
                    <p className="s-sub rv in d2" style={{ textAlign: 'right' }}>
                        Automatizaciones e integraciones que entregan valor inmediato a tu operación.
                    </p>
                </div>

                <div className="sol-grid">
                    {/* Tarjeta 1: Facturación */}
                    <div className="sol-card rv in">
                        <div className="sol-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                                <rect x="3" y="5" width="20" height="16" rx="2" />
                                <path d="M3 9h20M8 13h8M8 17h6" />
                            </svg>
                        </div>
                        <div className="sol-name">Automatización de Facturación</div>
                        <div className="sol-desc">
                            Genera, valida y envía facturas automáticamente desde tus sistemas actuales, sin errores y en tiempo real.
                        </div>
                        <div className="sol-items">
                            <div className="sol-item">Extracción automática de datos</div>
                            <div className="sol-item">Validación fiscal y normativa</div>
                            <div className="sol-item">Integración CFDI/Facturación electrónica</div>
                            <div className="sol-item">Reducción 95% de errores</div>
                        </div>
                    </div>

                    {/* Tarjeta 2: APIs ERP */}
                    <div className="sol-card rv in d1">
                        <div className="sol-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                                <circle cx="12" cy="12" r="9" />
                                <path d="M12 7v5l3 2" />
                                <path d="M3 3l6 6M20 3l-6 6" />
                            </svg>
                        </div>
                        <div className="sol-name">Integración APIs ERP</div>
                        <div className="sol-desc">
                            Conecta SAP, Odoo, NetSuite y otros ERPs sin costosas implementaciones. APIs robustas y tiempo real.
                        </div>
                        <div className="sol-items">
                            <div className="sol-item">Soporte SAP, Odoo, NetSuite y más</div>
                            <div className="sol-item">Sincronización de datos en tiempo real</div>
                            <div className="sol-item">Webhooks y APIs REST personalizadas</div>
                            <div className="sol-item">Zero downtime en tu operación</div>
                        </div>
                    </div>

                    {/* Tarjeta 3: Bases de Datos */}
                    <div className="sol-card rv in d2">
                        <div className="sol-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                            </svg>
                        </div>
                        <div className="sol-name">Conectividad de Bases de Datos</div>
                        <div className="sol-desc">
                            Acceso seguro y escalable a tus bases de datos — MySQL, PostgreSQL, SQL Server, Oracle y más.
                        </div>
                        <div className="sol-items">
                            <div className="sol-item">Soporte de múltiples DB engines</div>
                            <div className="sol-item">Encriptación end-to-end</div>
                            <div className="sol-item">Queries optimizadas y cacheadas</div>
                            <div className="sol-item">Auditoría completa de accesos</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Soluciones;